var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.direction)?_c('i',{class:("gobierto-table__column-selector__icon fas fa-sort-amount-" + _vm.icon)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }